<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      ref="grid"
      :actions="actions"
      :selectionEnabled="true"
    ></dx-grid>

    <v-dialog v-model="updateConflictsDialog" max-width="1000">
      <v-card>
        <v-card-title class="headline pb-0">
          Update Conflicts
          <span
            v-if="selected && selected.length"
            class="ml-2"
            style="font-size:0.85em; color:#888; font-weight:400;"
          >
            ({{ selected.length }} selected)
          </span>
        </v-card-title>
        <v-card-text style="overflow-y: auto; height: 450px;">
          <div v-if="errorMessages && errorMessages.length" class="mb-3">
            <v-alert type="error" value="true" dense outlined>
              <div v-for="(msg, idx) in errorMessages" :key="idx">
                {{ msg }}
              </div>
            </v-alert>
          </div>
          <div class="mb-3">
            <v-select
              v-model="selectedAction"
              :items="allActionOptions"
              item-text="label"
              item-value="value"
              item-disabled="disabled"
              label="Select Action"
              outline
              hide-details
              class="mb-2"
              style="width: 300px;"
            ></v-select>
          </div>
          <v-divider
            class="pb-2"
            style="margin-left: 0px !important; margin-right: 0px  !important; border-top: 1px solid #43a047;"
          ></v-divider>
          <v-data-table
            :headers="selectedHeaders"
            :items="selected"
            hide-actions
            class="elevation-1 mb-2"
            dense
          >
            <template v-slot:items="props">
              <tr style="border-bottom: unset !important">
                <td class="pb-1 pt-2" style="height: 30px;">
                  {{ props.item.id }}
                </td>
                <td class="pb-1 pt-2" style="height: 30px;">
                  {{ props.item.masterContactID }}
                </td>
                <td class="pb-1 pt-2" style="height: 30px;">
                  {{ props.item.conflictType }}
                </td>
                <td class="pb-1 pt-2" style="height: 30px;">
                  {{ props.item.personID }}
                </td>
                <td class="pb-1 pt-2" style="height: 30px;">
                  {{ props.item.field }}
                </td>
                <td class="pb-1 pt-2" style="height: 30px;">
                  {{ props.item.genvite }}
                </td>
                <td class="pb-1 pt-2" style="height: 30px;">
                  {{ props.item.uta }}
                </td>
              </tr>
              <tr>
                <td colspan="7" class="px-2 pb-1 pt-0" style="height: 30px;">
                  <v-layout row>
                    <v-flex
                      xs6
                      class="text--secondary"
                      style="font-size:0.8rem;"
                    >
                      <span class="font-weight-medium mr-2">Genvite:</span
                      >{{
                        formatDisplay([
                          props.item.genviteName,
                          props.item.addressLine1,
                          props.item.phoneNumber,
                        ])
                      }}
                    </v-flex>
                    <v-flex
                      xs6
                      class="text--secondary text-xs-right"
                      style="font-size:0.8rem;"
                    >
                      <span class="font-weight-medium mr-2">UTA:</span
                      >{{
                        formatDisplay([
                          props.item.utaName,
                          props.item.utaAddress,
                        ])
                      }}
                    </v-flex>
                  </v-layout>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="pb-3 pt-3">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="updateConflictsDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            color="success"
            :loading="loading"
            @click="saveConflictActions"
            :disabled="!selectedAction"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Genvite Conflict Details",
      url: "genviteConflictDetails",
      actions: [],
      updateConflictsDialog: false,
      selected: [],
      selectedAction: null,
      loading: false,
      errorMessages: [],

      selectedHeaders: [
        { text: "ID", value: "id", sortable: false },
        {
          text: "Master Contact ID",
          value: "masterContactID",
          sortable: false,
        },
        { text: "Conflict Type", value: "conflictType", sortable: false },
        { text: "Person ID", value: "personID", sortable: false },
        { text: "Field", value: "field", sortable: false },
        { text: "Genvite", value: "genvite", sortable: false },
        { text: "UTA", value: "uta", sortable: false },
      ],

      allActionOptions: [
        {
          value: "new-account-create",
          label: "New Account: Create New account",
        },
        {
          value: "new-account-link",
          label: "New Account: Link with existing account",
          disabled: true,
        },
        { value: "conflict-update", label: "Conflict: Update From Genvite" },
        { value: "conflict-ignore", label: "Conflict: Ignore" },
      ],

      columns: [
        {
          label: "ID",
          field: "id",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Master Contact ID",
          field: "masterContactID",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Conflict Type",
          field: "conflictType",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Person ID",
          field: "personID",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Field",
          field: "field",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Genvite",
          field: "genvite",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "UTA",
          field: "uta",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Genvite Name",
          field: "genviteName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Genvite Hebrew Name",
          field: "genviteHebrewName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Address Line 1",
          field: "addressLine1",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Phone Number",
          field: "phoneNumber",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "UTA Name",
          field: "utaName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "UTA Hebrew Name",
          field: "utaHebrewName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "UTA Address",
          field: "utaAddress",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Import ID",
          field: "importID",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Action",
          field: "action",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "By User",
          field: "byUser",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Date Updated",
          field: "dateUpated",
          type: "date",
          format: "MM/dd/yyyy hh:mm:ss a",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
      ],
    };
  },
  created() {
    this.actions.push({
      text: "Update Conflicts",
      action: this.openUpdateConflictsDialog,
      showOnSelection: true,
    });
  },
  methods: {
    formatDisplay(values) {
      // Filter out null, undefined, and empty strings, then join with " | "
      return values.filter((v) => v != null && v !== "").join(" | ");
    },
    openUpdateConflictsDialog() {
      this.selected = this.$refs.grid.getSelectedRowsData();
      this.selectedAction = null;
      this.errorMessages = [];
      this.updateConflictsDialog = true;
    },
    getActionOptions(type) {
      if (["C", "D"].includes(type)) {
        return [
          { value: "conflict-update", label: "Conflict: Update From Genvite" },
          { value: "conflict-ignore", label: "Conflict: Ignore" },
        ];
      } else if (type === "A") {
        return [
          {
            value: "new-account-create",
            label: "New Account: Create New account",
          },
          {
            value: "new-account-link",
            label: "New Account: Link with existing account",
          },
        ];
      }
      return [];
    },
    async saveConflictActions() {
      if (!this.selectedAction) {
        this.errorMessages = ["Please select an action"];
        return;
      }

      if (!this.selected || this.selected.length === 0) {
        this.errorMessages = ["Please select at least one conflict"];
        return;
      }

      this.loading = true;
      this.errorMessages = [];

      try {
        const payload = this.selected.map((item) => ({
          id: item.id,
          masterContactID: item.masterContactID,
          conflictType: item.conflictType,
          personID: item.personID,
          field: item.field,
          genvite: item.genvite,
          uta: item.uta,
          importID: item.importID,
          action: this.selectedAction,
          byUser: this.$store.state.authentication.user || "",
        }));

        const response = await this.$http.post(
          "api/genviteConflicts/updateConflicts",
          payload
        );

        // Handle error returned as a normal response
        if (response && response.error) {
          this.errorMessages = [response.error];
          if (Array.isArray(response.details) && response.details.length) {
            this.errorMessages = this.errorMessages.concat(response.details);
          }
          this.loading = false;
          return;
        }

        this.$notify({
          type: "success",
          group: "notification",
          text: "Conflicts updated successfully",
        });
        this.updateConflictsDialog = false;
        this.loading = false;
        this.errorMessages = [];
        this.selectedAction = null;

        // Refresh grid
        if (this.$refs.grid && this.$refs.grid.reloadGrid) {
          this.$refs.grid.reloadGrid();
        }
      } catch (err) {
        this.loading = false;
        // Handle API error response with details
        if (err && err.error) {
          this.errorMessages = [err.error];
          if (Array.isArray(err.details) && err.details.length) {
            this.errorMessages = this.errorMessages.concat(err.details);
          }
        } else {
          this.errorMessages = ["Failed to update conflicts"];
        }
      }
    },
  },
};
</script>

<style scoped></style>
